import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// tailwind-merge tiene que conocer las escalas propias (text-body, text-caption…) para no confundirlas con colores.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['display', 'h1', 'h2', 'h3', 'figure', 'body', 'label', 'caption', 'button-lg'] }],
      shadow: [{ shadow: ['popover', 'float', 'segment', 'none'] }],
    },
  },
});

/** Une clases condicionales y resuelve conflictos de Tailwind (la última gana). */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
